var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransparance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638:4519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37097 20.8047L8.84948 22.7966L12.4982 18.1543",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5045 21.5117H29.7096",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37097 29.4805L8.84948 31.4642L12.4982 26.8301",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5045 30.1875H23.5174",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37097 38.1543L8.84948 40.1381L12.4982 35.5039",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5045 38.8613H21.4208",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2269 14.7963V4.26766C36.2269 3.40517 35.8845 2.57824 35.2749 1.96837C34.6653 1.35849 33.8385 1.01562 32.9764 1.01562H10.0929L1.01581 8.89402V44.7311C1.01581 45.5936 1.35827 46.4209 1.96786 47.0308C2.57745 47.6407 3.40423 47.9831 4.26632 47.9831H32.9764C33.8385 47.9831 34.6653 47.6407 35.2749 47.0308C35.8845 46.4209 36.2269 45.5936 36.2269 44.7311V39.707",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0264 1.64258V11.6507H6.91547",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3894 35.5367L25.6709 38.7887L29.3846 28.0406L43.2805 14.138C44.0525 13.3738 45.5477 13.6095 46.6042 14.6664L50.0091 18.0729C51.0655 19.1298 51.3011 20.6258 50.5373 21.39L36.3894 35.5367Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3163 34.2445L30.3191 28.2363",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9377 37.6266L26.9955 35.6348",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.529 31.325L41.3952 23.4551",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4607 17.2754L47.3924 24.2104",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638:4519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 49,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparance);
export default __webpack_public_path__ + "static/media/transparance.74107c96.svg";
export { ForwardRef as ReactComponent };